import React, { useEffect } from 'react'
import { useState } from 'react'
import { Button, Card, Carousel, Col, Input, Row } from 'reactstrap'
import GetBrandProfileListService from '../../../../../../../../../Service/DashboardServices/QuestionnaireServices/GetBrandProfileListService';
import { connect } from 'react-redux';
import GetFileListByCategoryService from '../../../../../../../../../Service/DashboardServices/AssetGalleryServices/GetFileListByCategoryService';
import BackButton from "../../../../.././../../../../designUtils/Logo/BackButton.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTimes, faAngleDown, faAngleUp, faCloudUploadAlt, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import RenameFileAssetNewService from '../../../../../../../../../Service/DashboardServices/AssetGalleryServices/RenameFileAssetNewService';
import TickMark from '../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/TickMark.svg'
import Rename from '../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Rename.svg'
import Download from '../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Download.svg'
import Close from '../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Close.svg'
import CustomModal from '../../../../../../../../Components/Modals/CustomModal';
import UploadBrandImages from './SubComponents/UploadBrandImages';
function BrandImage(props) {
    const [subCategoryId, setSubCategoryId] = useState()
    const [brandProfile, setBrandProfile] = useState();
    const [fileListOfAssets, setFileListOfAssets] = useState(false);
    const [assetImagePage, setAssetImagePage] = useState(false);
    const [brandId, setBrandId] = useState();
    const [isInfoTabOpen, setIsInfoTabOpen] = useState(false)
    const [brandname, setBrandname] = useState()
    const [selectedFileObject, setSelectedFileObject] = useState();
    const [editedFileName, setEditedFileName] = useState();
    const [isClickEditName, setIsClickEditName] = useState(false);
    const [isOpengalleryPopUp, setIsOpengalleryPopUp] = useState(false)
    const [imageUrl, setImageUrl] = useState(false)
    const [uploadImagesPage, setUploadImagesPage] = useState(false)

    // const [renderPage,]


    useEffect(() => {
        let data = {
            integerId: props.storeOverview.integerID
        }
        GetBrandProfileListService(props.token, data).then((response) => {
            if (response) {
                setBrandProfile(response.brandList);
                console.log(response);
            }
        });
    }, []);
    console.log(props)
    const GetFileListByCategory = (e) => {
        setBrandId(e.target.value);
        setBrandname(e.target.options[e.target.selectedIndex].text);
        let data = {
            integerId: props.storeOverview.integerID,
            assetCategory: 1,
            assetIdentifier: e.target.options[e.target.selectedIndex].text,
        };
        GetFileListByCategoryService(props.token, data).then((response) => {
            if (response) {
                // Filter fileList to include only .jpg, .png, and .jpeg images
                const imageFiles = response.fileList.filter(file => {
                    // Get the file extension by splitting the fileName and getting the last part
                    const extension = file.fileName.toLowerCase().split('.').pop();
                    // Check if the extension is one of .jpg, .png, or .jpeg
                    return ['jpg', 'png', 'jpeg'].includes(extension);
                });

                // Set the filtered list
                setFileListOfAssets(imageFiles);
                console.log(response.fileList);
                setAssetImagePage(true)
                // setIsInfoTabOpen(false)
            }
        });
        // getAllOriginalFilesByAssetIdentifier( e.target.options[e.target.selectedIndex].text)

    }


    const handleBackbutton = () => {
        setAssetImagePage(false)
    }
    const handleOpenInfo = (file) => {
        setIsInfoTabOpen(true)
        setSelectedFileObject(file)
    }
    const handleCloseFileInfo = () => {
        setIsInfoTabOpen(false)
        setSelectedFileObject(false)
    }
    const handleAssetsLibrery = (asset) => {
        setImageUrl(asset.filePath)
        setEditedFileName()
        setIsOpengalleryPopUp(true);
    }
    console.log(selectedFileObject)
    const handleSaveRename = (imageUrl) => {
        let data;
        if (imageUrl != '') {
            fileListOfAssets.map((img) => {
                if (img.filePath == imageUrl)
                    data = {
                        integerId: props.storeOverview.integerID,
                        assetCategory: 1,
                        assetIdentifier: selectedFileObject.assetIdentifier,
                        newName: editedFileName,
                        fileId: selectedFileObject.id
                    }
            })
        }
        else {
            data = {
                integerId: props.storeOverview.integerID,
                assetCategory: 1,
                assetIdentifier: selectedFileObject.assetIdentifier,
                newName: editedFileName,
                fileId: selectedFileObject.id

            }
        }
        RenameFileAssetNewService(props.token, data).then((response) => {
            if (response) {
                response.fileList.map((file) => {
                    if (file.id === selectedFileObject.id) {
                        setSelectedFileObject(file)
                    }
                })
                setIsClickEditName(false)
                const imageFiles = response.fileList.filter(file => {
                    // Get the file extension by splitting the fileName and getting the last part
                    const extension = file.fileName.toLowerCase().split('.').pop();
                    // Check if the extension is one of .jpg, .png, or .jpeg
                    return ['jpg', 'png', 'jpeg'].includes(extension);
                });

                // Set the filtered list
                setFileListOfAssets(imageFiles);
                setEditedFileName()
                console.log(response)
            }
        })
    }
    const handleAssetsSlider = () => {
        const imageUrls = fileListOfAssets && fileListOfAssets.reduce((acc, fileUrl) => {
            if (getImageExtension(fileUrl.filePath) != null) {
                return acc.concat(fileUrl.filePath);
            }
            return acc;
        }, []);

        return <Carousel images={imageUrls} />;
    }
    const getImageExtension = (imageUrl) => {
        const matches = imageUrl.match(/\.(jpg|jpeg|png|svg)$/i);
        if (matches) {
            if (matches.length > 1) {
                return matches['input']
            }
            else {
                return null
            }
        }
        else {
            return null;
        }
    };
    const handleUploadAssetsLibreryPage = () => {
        return (
            <UploadBrandImages
                setIsUploadAssetGallery={setUploadImagesPage} />
        )
    }
    const renderBrandTab = () => {
        return (
            <>
                <Row>
                    <Col md={isInfoTabOpen ? 6 : 12}>
                        <Card className='p-2 mb-3 child-card' >


                            <Row>
                                <Col md={12}>
                                    <div className='d-flex justify-content-between'>
                                        <div className='d-flex'>
                                            <button onClick={() => handleBackbutton()} className="hover-btn-link back-btn ml-2 mr-1 "  >
                                                <img src={BackButton} alt="not found" />
                                            </button>
                                            <h5 className=''><b>{brandname}</b></h5>
                                        </div>
                                        {subCategoryId &&
                                            (
                                                <Button
                                                    onClick={() => { setUploadImagesPage(true); setIsInfoTabOpen(false); }}
                                                    className='btn-background-color-Proceed-gallery  ml-2'
                                                    disabled={!brandId}
                                                >
                                                    Upload Assets
                                                </Button>
                                            )}

                                    </div>

                                </Col>
                                <Col md={12}>
                                    <div className='d-flex'>
                                        {props.subCategory && props.subCategory.map((sub) => (
                                            <h5 className={`${sub.id === subCategoryId ? 'selected-tab-assets-tab ' : 'assets-tab-not-selected'}`}
                                                onClick={() => { setSubCategoryId(sub.id); setIsInfoTabOpen(false) }}
                                            >
                                                <b>{sub.subCategoryName}</b>
                                            </h5>
                                        ))
                                        }
                                    </div>

                                </Col>
                            </Row>
                        </Card>
                        {
                            subCategoryId === 1 && (
                                <Card className='p-2 child-card'>
                                    <Row>
                                        {
                                            fileListOfAssets && Object.values(fileListOfAssets).map((asset) => (

                                                <Col sm={4} md={3}
                                                    onDoubleClick={() => handleAssetsLibrery(asset)}
                                                    onClick={() => handleOpenInfo(asset)}
                                                >
                                                    <Card
                                                        style={{ backgroundColor: selectedFileObject && selectedFileObject.id === asset.id ? '#D0EFB1' : '' }} className={`p-2 mt-2 mb-1 `}
                                                    >
                                                        <div>
                                                            <img src={asset.filePath} alt='not found' width={'100%'} height={'100%'} />
                                                            {/*  <p>File name {selectedFileObject.actualFileName}</p>     */}
                                                        </div>

                                                    </Card>
                                                </Col>
                                            ))
                                        }
                                    </Row>

                                </Card>
                            )
                        }
                        {
                            subCategoryId === 2 && (
                                <Card className='p-2 child-card'>
                                    <h1> work in progress</h1>

                                </Card>
                            )
                        }
                    </Col>
                    {isInfoTabOpen &&
                        <Col md={6}>
                            <Card className='p-2 mb-3 child-card'>
                                <div className='d-flex justify-content-end'>
                                    <button
                                        onClick={() => handleCloseFileInfo()}
                                        className='info-button-background-none'
                                        title='Close'>
                                        <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                </div>
                                <div>
                                    <img src={selectedFileObject.filePath} />
                                    <div className='d-flex align-items-center  '>

                                        {
                                            isClickEditName ?
                                                <>
                                                    <h6>
                                                        <Input
                                                            className='w-100 '
                                                            type='text'
                                                            value={editedFileName ? editedFileName : selectedFileObject.actualFileName}
                                                            onChange={(e) => setEditedFileName(e.target.value)}
                                                        />
                                                    </h6>&nbsp;
                                                    <h6>
                                                        <button
                                                            title='save'
                                                            className='info-button-background-none'
                                                            onClick={() => handleSaveRename('')}
                                                            disabled={!editedFileName}
                                                        >
                                                            <img className='button-img-background-assets' src={TickMark} alt='not found' />
                                                        </button>
                                                    </h6>
                                                </>
                                                : (<>
                                                    <h6> <b>{selectedFileObject.actualFileName}</b>&nbsp;
                                                        <button
                                                            title='Edit'
                                                            className='info-button-background-none'
                                                        // onClick={() => handleRenameFileAssets()}
                                                        >
                                                            <img className='button-img-background-assets p-1' src={Rename} alt='not found' />
                                                        </button></h6></>)
                                        }
                                        <button
                                            // onClick={() => handleDownloadImage(selectedFileObject.filePath, "DownloadeImage")}
                                            className='info-button-background-none mb-1'
                                            title='Downlod'
                                        >
                                            <img className='button-img-background-download  p-1' src={Download} alt='not found' />
                                        </button>

                                    </div>
                                    <div className='d-flex justify-content-between'>
                                        <h6 className='d-flex justify-content-between'>
                                            <b>{selectedFileObject.fileSize}</b>  </h6>
                                        <h6>   Last Modified on <b>{selectedFileObject.createdAt}</b>
                                        </h6>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    }
                </Row>
                <CustomModal
                    isOpen={isOpengalleryPopUp}
                    toggle={() => { setIsOpengalleryPopUp(!isOpengalleryPopUp); setIsClickEditName(false) }}
                    size={"lg"}
                    className="asset-carousel"
                >
                    <Row
                        className={`m-1`}>
                        <Col md={12} className=''>
                            {
                                selectedFileObject && (
                                    <div className='d-flex justify-content-between mb-2'>
                                        <div className='d-flex align-items-center mb-2'>
                                            {/* File Name */}
                                            <h6 style={{ color: '#fff' }}>
                                                <b>File Name : </b>&nbsp;
                                            </h6>
                                            {/* Edit File Name Input */}
                                            {isClickEditName ? (
                                                <>
                                                    <Input
                                                        className='w-50'
                                                        type='text'
                                                        value={editedFileName ? editedFileName : selectedFileObject.actualFileName}
                                                    // onChange={(e) => setEditedFileName(e.target.value)}
                                                    />&nbsp;
                                                    <h6>
                                                        <button
                                                            title='save'
                                                            className='info-button-background-none'
                                                            // onClick={() => handleSaveRename(imageUrl)}
                                                            disabled={!editedFileName}
                                                        >
                                                            <img className='carousel-img-background-none' src={TickMark} alt='not found' />
                                                        </button>
                                                    </h6>
                                                </>
                                            ) : (
                                                <h6 style={{ color: '#fff' }}>
                                                    {editedFileName ? editedFileName : selectedFileObject.actualFileName} &nbsp;
                                                    <button
                                                        title='Edit'
                                                        className='info-button-background-none'
                                                    // onClick={() => handleRenameFileAssets()}
                                                    >
                                                        <img className='carousel-img-background-none p-1' src={Rename} alt='not found' />
                                                    </button>
                                                </h6>
                                            )}
                                            {/* Download Button */}
                                            <h6>
                                                <button
                                                    // onClick={() => handleDownloadImage(selectedFileObject.filePath, "DownloadeImage")}
                                                    className='info-button-background-none'
                                                    title='Download'
                                                >
                                                    <img className='carousel-img-background-none-download p-1' src={Download} alt='not found' />
                                                </button>
                                            </h6>
                                        </div>
                                        {/* Close Button */}
                                        <div className='ml-auto'>
                                            <button
                                                onClick={() => { setIsOpengalleryPopUp(false); setIsClickEditName(false) }}
                                                className='info-button-background-none '
                                                title='Close'
                                            >
                                                <img src={Close} alt='not found' />
                                                {/* <img className=' text-white p-1' src={Close} alt='not found' /> */}
                                            </button>
                                        </div>
                                    </div>

                                )}
                            <div className='file-view-div'>
                                <img
                                    src={imageUrl}
                                    style={{ background: '#fff' }}
                                    title="File Display"
                                    className='file-view p-2'
                                />
                                <h6 className='d-flex justify-content-center delete-btn-popup' >
                                    <Button
                                        // onClick={() => {handleDeleteFile(imageUrl,'image');}}
                                        className='delete-button-background-none mt-1'>
                                        <FontAwesomeIcon icon={faTrash} /> &nbsp;
                                        Delete
                                    </Button>
                                </h6>
                            </div>
                        </Col>
                        <Col md={12} className=''>
                            {handleAssetsSlider()}
                        </Col>
                    </Row>
                </CustomModal>
            </>
        )
    }
    const renderBrandDropdown = () => {
        return (
            <>
                < Card className='p-2 child-card '>
                    <h6><b>Choose your brand</b></h6>
                    <select
                        className="form-control w-25 mb-3"
                        onChange={(e) => { GetFileListByCategory(e); }}
                    >
                        <option >--Select Brand --</option>
                        {brandProfile && brandProfile.map((brand) => (
                            <option
                                key={brand.id}
                                value={brand.id}>{brand.brandName}</option>
                        ))}
                    </select>

                </Card>
            </>
        )
    }
    return (
        <>
            {uploadImagesPage ? handleUploadAssetsLibreryPage() :
                assetImagePage ? renderBrandTab() : renderBrandDropdown()}

        </>


    )
}
const mapStateToProps = (state) => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        storeOverview: state.accountOverview.store.storeOverview,
    };
};

export default connect(mapStateToProps)(BrandImage);